var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.479619 154.063238V852.358095h52.150857v-1.024l120.295619 0.024381V441.051429l-120.295619-41.862096v-78.506666l169.252572 58.855619a56.32 56.32 0 0 1 25.795047 42.959238l0.170667 4.388571V852.358095H902.095238V926.47619H121.904762v-74.093714h56.953905v-566.613333c0-19.456 10.166857-37.546667 26.843428-47.85981l304.444953-131.705904c38.034286-23.503238 87.332571 3.510857 87.332571 47.859809z m-74.922667 27.623619L253.805714 297.959619v553.447619h268.751238V542.183619l-0.487619 0.195048V508.099048l0.487619 1.170285v-142.555428l-0.487619 0.195047v-34.133333l0.487619 1.097143V181.686857zM471.771429 482.816v80.14019l-167.107048 68.217905v-80.14019l167.107048-68.217905z m0-175.225905v80.481524l-167.107048 70.314667V377.904762l167.107048-70.290286z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.721d147189a72ce7428e8a28938a7bb8.svg";
export { ForwardRef as ReactComponent };